export default "__VITE_ASSET__D39q0VVT__"